import { NavLink } from 'react-router-dom';
import { SidebarLinkTypes } from './types';

import styles from './sidebar.module.css';

export default function SidebarLink({
  label,
  to,
  onClick,
  onMouseDown,
}: SidebarLinkTypes): React.JSX.Element {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        `${styles.sidebarLink} ${isActive ? styles.activeLink : ''}`
      }
      onMouseDown={(e) => onMouseDown && onMouseDown(e)}
      onClick={() => onClick && onClick()}
    >
      {label}
    </NavLink>
  );
}
